import { render } from "./SellView.vue?vue&type=template&id=0f8bedc5&scoped=true"
import script from "./SellView.vue?vue&type=script&lang=js"
export * from "./SellView.vue?vue&type=script&lang=js"

import "./SellView.vue?vue&type=style&index=0&id=0f8bedc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8bedc5"]])

export default __exports__